import { render, staticRenderFns } from "./chatList.vue?vue&type=template&id=700d6287&scoped=true"
import script from "./chatList.vue?vue&type=script&lang=js"
export * from "./chatList.vue?vue&type=script&lang=js"
import style0 from "./chatList.vue?vue&type=style&index=0&id=700d6287&prod&lang=scss&scoped=true"
import style1 from "./chatList.vue?vue&type=style&index=1&id=700d6287&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700d6287",
  null
  
)

export default component.exports